var neutral = {
  variant: 'neutral'
};
var alert = {
  variant: 'alert'
};
var accent = {
  variant: 'accent'
};
var tagInnerVariants = {
  neutral: neutral,
  alert: alert,
  accent: accent
};

export { tagInnerVariants };
//# sourceMappingURL=tag-inner.variants.esm.js.map
